import { RootComponent } from "./components/RootComponent";
import { CanvasComponent } from "./components/CanvasComponent";
import { StartupComponent } from "./components/StartupComponent";
import { NotFoundComponent } from "./components/NotFoundComponent";
import { LevelSelectorComponent } from "./components/LevelSelectorComponent";
import { IntroductionComponent } from "./components/IntroductionComponent";
import { InventoryComponent } from "./components/InventoryComponent";
import { EndingComponent } from "./components/EndingComponent";
import { PauseMenuComponent } from "./components/PauseMenuComponent";

// Expose the web components to the browser
// TODO: waarom bestaan startup-screen en level-selector al? Dit zou niet mogen gebeuren, maar we hebben dit nodig om de tests te laten werken. We moeten dit oplossen in de tests, zodat we zeker weten dat er maar 1 definitie is van deze componenten.
window.customElements.define("game-root", RootComponent);
window.customElements.define("game-canvas", CanvasComponent);
window.customElements.define("game-notfound", NotFoundComponent);
window.customElements.define("game-inventory", InventoryComponent);
window.customElements.define("pause-menu", PauseMenuComponent);

if (!customElements.get("introduction-component")) {
    window.customElements.define("introduction-component", IntroductionComponent);
}

if (!customElements.get("startup-screen")) {
    window.customElements.define("startup-screen", StartupComponent);
}

if (!customElements.get("level-selector")) {
    window.customElements.define("level-selector", LevelSelectorComponent);
}

if (!customElements.get("ending-component")) {
    window.customElements.define("ending-component", EndingComponent);
}

if (!customElements.get("pause-menu")) {
    window.customElements.define("pause-menu", PauseMenuComponent);
}
